import { createContext, useContext, useRef, useCallback, useSyncExternalStore, useEffect } from "react";
import _ from "lodash";

const createStore = (initialState) => {
  let state = initialState;
  const listeners = new Set();

  return {
    getState: () => state,
    setState: (nextState) => {
      if (!_.isEqual(state, nextState)) {
        state = nextState;
        listeners.forEach((l) => l());
      }
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    }
  };
};

const DataGridContext = createContext(null);

export const DataGridProvider = ({ children, state }) => {
  const storeRef = useRef(createStore(state));

  // storeRef.current.setState(state);
  useEffect(() => {
    storeRef.current.setState(state);
  }, [state]);

  return (
    <DataGridContext.Provider value={storeRef.current}>
      {children}
    </DataGridContext.Provider>
  );
};

export const useGridData = (field) => {
  const store = useContext(DataGridContext);

  const subscribe = useCallback((cb) => store.subscribe(cb), [store]);
  const getSnapshot = useCallback(() => _.get(store.getState(), field), [store, field]);

  return useSyncExternalStore(subscribe, getSnapshot);
};

export default DataGridContext;